import { TimeUnitsConverterService } from './time-units-converter.service';

export class TimeUnitsIME {
  private inputText: string;
  private hasFocus: boolean;

  constructor(
    private valueGetter: () => number,
    private valueSetter: (value: number) => void,
    private timeUnitsConverter: TimeUnitsConverterService
  ) {}

  get model(): string {
    if (this.hasFocus) {
      return this.inputText;
    }

    return this.timeUnitsConverter.transform(this.valueGetter());
  }
  set model(value: string) {
    this.inputText = value;
    this.valueSetter(this.timeUnitsConverter.parse(value));
  }

  get isValid(): boolean {
    return this.timeUnitsConverter.isValid(this.model);
  }

  focus(): void {
    this.inputText = this.timeUnitsConverter.transform(this.valueGetter());
    this.hasFocus = true;
  }

  blur(): void {
    this.hasFocus = false;
  }
}
